/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/symbol-observable/index.js
// module id = 497
// module chunks = 0